import { z } from "zod";
import { QcUserSchema } from "../conversation/QcUser";

export type ModelUserContactList = z.infer<typeof ModelUserContactListSchema>;
export const ModelUserContactListSchema = z.object({
  items: z.array(QcUserSchema),
  nextPage: z.number(),
});
